import { constants } from '..';

const INITIAL_STATE = {
  loading: false,
  assignableLocationsLoading: false,
  activityRecordsLoading: false,
  admins: [],
  total: 0,
  selectedAdmin: {},
  assignableLocations: [],
  activityRecords: [],
  activityRecordsTotal: 0,
};

export const adminsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.admins.SET_ADMINS_LOADING:
      return {
        ...state,
        loading: action.flag,
      };
    case constants.admins.SET_ASSIGNABLE_LOCATIONS_LOADING:
      return {
        ...state,
        assignableLocationsLoading: action.flag,
      };
    case constants.admins.SET_ACTIVITY_RECORDS_LOADING:
      return {
        ...state,
        activityRecordsLoading: action.flag,
      };
    case constants.admins.SET_ADMINS:
      return {
        ...state,
        admins: action.admins,
        total: action.count,
      };
    case constants.admins.SET_ASSIGNABLE_LOCATIONS:
      return {
        ...state,
        assignableLocations: action.locations,
      };
    case constants.admins.SET_ACTIVITY_RECORDS:
      return {
        ...state,
        activityRecords: action.records,
        activityRecordsTotal: action.total,
      };
    case constants.admins.CLEAR_ADMINS:
      return {
        ...INITIAL_STATE,
      };
    case constants.admins.SET_ADMIN:
      return {
        ...state,
        selectedAdmin: action.admin,
      };
    default:
      return state;
  }
};
